/* global i18n, notify  */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { flatten, pathEq, reject, values, compose } from 'ramda'
import { isNotEmpty } from 'ramda-adjunct'
import Button from '../../../../components/Button/Button.jsx'
import { xhrPostErr } from '../../../../helpers/http.js'
import { baseUrl } from '../../../../common/constants.js'
import s from '../../style.module.scss'

const VoucherPay = () => {
  const [form, setForm] = React.useState({})
  const handleForm = (name, value) => {
    setForm({ ...form, [name]: value })
  }

  const flatItemList = useSelector((state) => flatten(values(state.Cart.items)))

  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.Cart.isLoading)
  const setIsLoading = (isLoading) => {
    dispatch({
      type: 'Cart.setIsLoading',
      payload: {
        isLoading
      }
    })
  }

  const setItems = (items) => {
    dispatch({
      type: 'Cart.setItems',
      payload: {
        items
      }
    })
  }

  const apiVoucherPay = async () => {
    return xhrPostErr(`${baseUrl}/web/cart/payment/coupon`, form)
  }

  const VoucherPay = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    const dta = await apiVoucherPay()
    if (dta.status === '400') {
      const errorMessage = Object.keys(dta.messages)
        .map(function (x) {
          return dta.messages[x].message
        })
        .join('<br>')

      notify(i18n.t('global_usecoupon_error'), errorMessage, 'error')
    }
    if (parseInt(dta.status) === 200) {
      let message = ''
      if ('message' in dta) {
        message = dta.message
      } else {
        message = i18n.t('global_usecoupon_sucess')
      }
      notify(i18n.t('global_sucess'), message, 'success')
      if ('cart' in dta) {
        setItems(dta.cart)
      }
    }

    if (parseInt(dta.status) === 400) {
      const errorMessage = Object.keys(dta.messages)
        .map(function (x) {
          return dta.messages[x].message
        })
        .join('<br>')
      notify(i18n.t('global_balance_error'), errorMessage, 'error')
    }

    setIsLoading(false)
  }

  const hasVoucherPayableItems = compose(
    isNotEmpty,
    reject(pathEq(['commerceinfo', 'statusText'], 'payment pending'))
  )(flatItemList)

  return (
    <>
      <h3>{i18n.t('cart_voucher_payment_header')}</h3>
      <div className={s.paymentInfoContainer}>
        <h4>{i18n.t('cart_voucher_payment_info_header')}</h4>
        <div>{i18n.t('cart_voucher_payment_info_text')}</div>
      </div>
      <form id="paymentform_2" className={s.couponuseForm} method="post" onSubmit={VoucherPay}>
        <h3>{i18n.t('cart_voucher_pay')}</h3>

        <div className={s.formRow}>
          <div className={s.formRowItem}>
            <label className="smalllabel text-left" htmlFor="Input-51391">
              app.couponId
            </label>

            <input
              className="form-control"
              id="Input-51391"
              type="text"
              name="couponid"
              onChange={(e) => handleForm('couponid', e.target.value)}
            />
          </div>

          <div className={s.formRowItem}>
            <label className="smalllabel text-left" htmlFor="Input-78594">
              app.couponCode
            </label>

            <input
              className="form-control"
              form="usecoupon"
              id="Input-78594"
              type="text"
              name="couponcode"
              onChange={(e) => handleForm('couponcode', e.target.value)}
            />
          </div>

          <div className={s.formRowItem}>
            <div className={s.bottomButtons}>
              <div className={s.primaryButtons}>
                <Button
                  className={`${s.btnPrimary} btn-primary`}
                  disabled={isLoading || !hasVoucherPayableItems}
                  onClick={VoucherPay}
                >
                  {i18n.t('cart_coupon_pay')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default VoucherPay
